import {useMemo} from 'react'

import useWebAppApiQuery from '$hooks/insurance/useWebAppApiQuery'
import {getCoveragesQuery} from '$queries/insurance/coverageQuery'

function useDetailCoveragesQuery() {
    const {isLoading, isError, isFetched, data} = useWebAppApiQuery({
        ...getCoveragesQuery.query(),
    })

    const result = useMemo(
        () => ({
            isLoading,
            isError,
            isFetched,
            data,
        }),
        [data, isError, isFetched, isLoading],
    )

    return result
}

export default useDetailCoveragesQuery
